import { ErrorHandler, Injectable, Injector } from '@angular/core';
import { LocationStrategy, PathLocationStrategy } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
/* Old, Unused */
//import { LoaderService } from '../loader/loader.service';
//import { loaderSource } from '../loader/loaderSourceEnum';
//import { loaderStyle } from '../loader/loaderStyleEnum';
import * as StackTrace from 'stacktrace-js';
import { Router } from '@angular/router';
/* NG Zorro Messaging Service used: Change for production */
import { NzMessageService } from 'ng-zorro-antd/message';
import { environment } from 'environments/environment';
import { AppConfig } from '../../../configs/app.config';

@Injectable({
  providedIn: 'root'
})
export class GlobalErrorHandler implements ErrorHandler {

  constructor(
    private injector: Injector,
    private appConfig: AppConfig
    // private msg: NzMessageService,
    ///private loaderService : LoaderService 
  ) { }

  handleError(error: Error | HttpErrorResponse) {
    // const loggingService = this.injector.get(LoggingService);
    const location = this.injector.get(LocationStrategy);

    const message = error.message ? error.message : error.toString();
    const url = location instanceof PathLocationStrategy ? location.path() : '';

    const router = this.injector.get(Router);
    const msg = this.injector.get(NzMessageService);
    let routeURL = this.appConfig.baseApiPathWithoutContext + "/assets/error-pages/error.html"

    /* Server Error */
    if (error instanceof HttpErrorResponse) {

    }
    /* Client Error */
    else {
      // Handle Client Error (Angular Error, ReferenceError...)
      // router.navigate(['/login'], { queryParams: {error: message} });
    }

    // get the stack trace, lets grab the last 10 stacks only
    StackTrace.fromError(error).then(stackframes => {
      const stackString = stackframes
        .splice(0, 20)
        .map(function (sf) {
          return sf.toString();
        }).join('\n');

      localStorage.setItem(url, JSON.stringify(stackString))
    });
    if (environment.globalErrorRouting) {
      window.location.href = routeURL;
    }

    if (!environment.production)
      console.error(error);
  }

  redirectOnServerError(serverError?) {
    let routeURL = this.appConfig.baseApiPathWithoutContext
    if (!serverError) {
      routeURL += "/assets/error-pages/error.html"
    }
    else if (serverError == 500) {
      routeURL += "/assets/error-pages/500.html"
    }
    else if (serverError == 400) {
      routeURL += "/assets/error-pages/400.html"
    }
    else if (serverError == 404) {
      routeURL += "/assets/error-pages/404.html"
    }
    else if (serverError == 422) {
      routeURL += "/assets/error-pages/422.html"
    }

    window.location.replace(routeURL);
  }

  testJSON(text) {
    if (typeof text !== "string") {
      return false;
    }
    try {
      JSON.parse(text);
      return true;
    }
    catch (error) {
      return false;
    }
  }

  sanitizeJSONResp(resp) {
    if (typeof resp["_body"] !== "string") {
      return {};
    }
    try {
      let c = JSON.parse(resp["_body"]);
      return c;
    }
    catch (error) {
      return this.logFailedAPI(resp);
    }
  }

  logFailedAPI(resp, url?, errorStatus?) {
    resp["errortimestamp"] = new Date()
    if (!url) {
      localStorage.setItem(resp["url"], JSON.stringify(resp))
    }
    else {
      localStorage.setItem(url, JSON.stringify(resp))
    }


    return {}
  }

}

